import gql from 'graphql-tag';

export const GET_GOLFCOURSE = gql`
    query ( $golf_group_code: String!,$golf_code: String ) {
        getGolfCourse (golf_group_code: $golf_group_code , golf_code: $golf_code ) {
            golf_code
            golf_group_code
            golf_name
            golu_kana
            zip_code
            prefecture_name
            municipality_name
            local_name
            building_name
            telephone
            fax
            valid_flag
            golf_course_img_path
            point_grant_type
            cell_link_type
            company_name
            api_url
            api_key
            api_office_code
            api_restaurant_url
        }
    }
`;

export const GET_GOLF_COURSE_NAME = gql`
    query ( $golf_group_code: String!) {
        getGolfCourse (golf_group_code: $golf_group_code ) {
            golf_code
            golf_name
        }
    }
`;

export const GET_POINT_GRANT_TYPE = gql`
    query ( $golf_code: String) {
        getPointGrantType (golf_code: $golf_code ) {
            point_grant_type
        }
    }
`;

export const GET_PLAY_TOGETHER_FIXED_DEADLINE = gql`
    query ( $reserve_no: String) {
        GetPlayTogetherFixedDeadline (reserve_no: $reserve_no ) {
            play_together_fixed_deadline
            play_date
        }
    }
`;

export const GET_GOLFCOURSE_VISIT = gql`
    query ( $golf_group_code: String!,$member_number: String ) {
        golfCourseListByVisit (golf_group_code: $golf_group_code , member_number: $member_number ) {
            golf_code
            golf_group_code
            golf_name
            golu_kana
            zip_code
            prefecture_name
            municipality_name
            local_name
            building_name
            telephone
            fax
            valid_flag
            golf_course_img_path
            point_grant_type
            cell_link_type
            company_name
            api_url
            api_key
            api_office_code
            api_restaurant_url
        }
    }
`;